import React from 'react'
import { keyframes, styled } from '@mui/material/styles'

const pulse = keyframes({
    '0%, 100%': { opacity: 1 },
    '50%': { opacity: 0.55 }
})

const SkeletonBlock = styled('div')({
    position: 'absolute',
    inset: 0,
    backgroundColor: '#eef1ef',
    borderRadius: 9,
    animation: `${pulse} 1.4s ease-in-out infinite`,
    pointerEvents: 'none'
})

export default function TcmProgress() {
    return <SkeletonBlock aria-hidden="true" />
}
